import { Yup } from "components/DynamicForm/utils";
import { COURIERS, DYNAMIC_TYPE_INPUT_TYPE, JSON_TABLE_INPUT_TYPE, SELECT_INPUT_TYPE } from "utils/Constants";
import DynamicFormOptions from "utils/DynamicFormOptions";

const form = {
    "trackingKey": "Prealerta Paquete",
    sections: [{
        fields: [
            [
                {
                    "type": "text",
                    "name": "tracking_num",
                    "validation": Yup.string().required(),
                    "label": "Numero Tracking",
                    "description": "Numero de seguimiento para realizar el rastreo del paquete",
                    "sizing": {
                        "sm": 7
                    }
                },
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "courier",
                    "validation": Yup.string().required(),
                    "creatable": true,
                    "label": "Transportista",
                    "trackValue": true,
                    "description": "Empresa que realiza el envio del paquete dentro de Estados Unidos",
                    "options": COURIERS
                },
            ],
            [
                {
                    "type": "text",
                    "name": "provedor",
                    "validation": Yup.string().required(),
                    "placeholder": "Amazon",
                    "trackValue": true,
                    "description": "Tienda donde se realizo la compra del producto",
                    "label": "Proveedor (Tienda)"
                },
                {
                    "type": "money",
                    "name": "cost",
                    "validation": Yup.number().required().positive(),
                    "description": "Precio del producto incluyendo el costo del envio y los impuestos ",
                    "label": "Precio",
                    "isDecimal": true,
                    "placeholder": "0,00",
                    "disableIf": {
                        "tax_calculated": [{ "eq": true }]
                    },
                    "step": ".01",
                    "sizing": {
                        "sm": 5
                    }
                },
            ],
            [
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "dynamicType": "number",
                    "name": "weigth",
                    "min": "0",
                    "step": ".01",
                    "disabled": true,
                    "hideOnCreate": true,
                    "label": "Peso",
                    "description": "Peso del producto en Libras",
                    "sizing": {
                        "sm": 6
                    },
                    "options": {
                        "lb": "Lbs",
                        "kg": "Kg",
                    },
                    "defaultOption": "lbs"
                },
            ],
            [{
                "type": SELECT_INPUT_TYPE,
                "name": "delivery_type",
                "label": "Lugar de Entrega",
                "description": "Lugar de entrega para el paquete una vez que el paquete llegue a Costa Rica",
                "validation": Yup.string().required(),
                "sizing": {
                    "sm": 5
                }
            }],
            [
                {
                    "type": JSON_TABLE_INPUT_TYPE,
                    "validation": Yup.string().required("REQUIRED_JSON_TABLE_ERROR"),
                    "trackValue": true,
                    "dataSchema": {
                        "cant": {
                            "label": "Cant",
                            "type": "number",
                            "min": "0",
                            "headingWidth": "col-2 col-xs-2",
                        },
                        "description": {
                            "label": "Description",
                            "type": "text",
                            "min": "0",
                            "trackValue": true,
                            "headingWidth": "col-6 col-xs-7",
                        },
                        "price": {
                            "label": "Precio",
                            "type": "money",
                            "isDecimal": true,
                            "placeholder": "0,00",
                            "step": ".01",
                            "headingWidth": "col-4 col-xs-3",
                        }
                    },
                    "name": "commotity",
                    "description": "Descripcion detallada del contenido del paquete",
                    "legend": "Contenido de Paquete"
                },
            ],
            // [
            //     {
            //         "type": "checkbox",
            //         "name": "exempt_process_request",
            //         "label": "Solicitar proceso de Exeneracion"
            //     },
            // ] 
        ]
    }]
};


export default form;